import _, {LoDashStatic} from 'lodash'
import Vue from 'vue'
// @ts-ignore
import * as lineClamp from 'vue-line-clamp'
import Vuelidate from 'vuelidate'
// @ts-ignore
import Chartkick from 'vue-chartkick'
// @ts-ignore
import Chart from 'chart.js'
import {sync} from 'vuex-router-sync'
import App from './App.vue'
import actuator from './plugins/actuator.plugin'
import httpPlugin from './plugins/http.plugin'
import banzaiBooks from './plugins/banzai-books.plugin'
import banzaiClaim from './plugins/banzai-claim.plugin'
import banzaiCollections from './plugins/banzai-collections.plugin'
import banzaiReadLists from './plugins/banzai-readlists.plugin'
import banzaiFileSystem from './plugins/banzai-filesystem.plugin'
import banzaiLibraries from './plugins/banzai-libraries.plugin'
import banzaiReferential from './plugins/banzai-referential.plugin'
import banzaiSeries from './plugins/banzai-series.plugin'
import banzaiUsers from './plugins/banzai-users.plugin'
import banzaiTransientBooks from './plugins/banzai-transientbooks.plugin'
import banzaiSse from './plugins/banzai-sse.plugin'
import banzaiTasks from './plugins/banzai-tasks.plugin'
import banzaiSyncPoints from './plugins/banzai-syncpoints.plugin'
import banzaiOauth2 from './plugins/banzai-oauth2.plugin'
import banzaiLogin from './plugins/banzai-login.plugin'
import banzaiPageHashes from './plugins/banzai-pagehashes.plugin'
import banzaiMetrics from './plugins/banzai-metrics.plugin'
import banzaiHistory from './plugins/banzai-history.plugin'
import banzaiSettings from './plugins/banzai-settings.plugin'
import banzaiFonts from './plugins/banzai-fonts.plugin'
import vuetify from './plugins/vuetify'
import logger from './plugins/logger.plugin'
import './public-path'
import router from './router'
import store from './store'
import i18n from './i18n'

Vue.prototype.$_ = _
Vue.prototype.$eventHub = new Vue()

Chartkick.options = {
  colors: [
    '#7eb0d5', '#fd7f6f', '#b2e061', '#ffb55a',
    '#8bd3c7', '#ffee65', '#bd7ebe', '#fdcce5',
    '#beb9db', '#ea5545', '#f46a9b', '#ef9b20',
    '#edbf33', '#ede15b', '#bdcf32', '#87bc45',
    '#27aeef', '#b33dc6',
  ],
}

Vue.use(Vuelidate)
Vue.use(lineClamp)
Vue.use(Chartkick.use(Chart))

Vue.use(httpPlugin)
Vue.use(logger)
Vue.use(banzaiSettings, {store: store, http: Vue.prototype.$http})
Vue.use(banzaiFileSystem, {http: Vue.prototype.$http})
Vue.use(banzaiSeries, {http: Vue.prototype.$http})
Vue.use(banzaiCollections, {http: Vue.prototype.$http})
Vue.use(banzaiReadLists, {http: Vue.prototype.$http})
Vue.use(banzaiBooks, {http: Vue.prototype.$http})
Vue.use(banzaiReferential, {http: Vue.prototype.$http})
Vue.use(banzaiClaim, {http: Vue.prototype.$http})
Vue.use(banzaiTransientBooks, {http: Vue.prototype.$http})
Vue.use(banzaiUsers, {store: store, http: Vue.prototype.$http})
Vue.use(banzaiLibraries, {store: store, http: Vue.prototype.$http})
Vue.use(banzaiSse, {eventHub: Vue.prototype.$eventHub, store: store})
Vue.use(actuator, {http: Vue.prototype.$http})
Vue.use(banzaiTasks, {http: Vue.prototype.$http})
Vue.use(banzaiSyncPoints, {http: Vue.prototype.$http})
Vue.use(banzaiOauth2, {http: Vue.prototype.$http})
Vue.use(banzaiLogin, {http: Vue.prototype.$http})
Vue.use(banzaiPageHashes, {http: Vue.prototype.$http})
Vue.use(banzaiMetrics, {http: Vue.prototype.$http})
Vue.use(banzaiHistory, {http: Vue.prototype.$http})
Vue.use(banzaiFonts, {http: Vue.prototype.$http})

Vue.config.productionTip = false

sync(store, router)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')

declare module 'vue/types/vue' {
  interface Vue {
    $_: LoDashStatic;
    $eventHub: Vue;
  }
}

declare global {
  interface Window {
    resourceBaseUrl: string
  }
}
